import {UserModel} from '../models/UserModel'

    function GetCurrentUser() {
        const user = localStorage.getItem('currentUser');
        console.log("getcurrent =>",user);
        const resp = user != null ? JSON.parse(JSON.stringify(user.toString())) : user;
        return resp;
    }

    function SetCurrentUser(user:string){
        localStorage.setItem('currentUser',user);
    }

    export default  {
        GetCurrentUser,
        SetCurrentUser
    };

 

